import { AbstractControl, ValidationErrors } from '@angular/forms';

/*
  (?=.*\d)          // should contain at least one digit
  (?=.*[a-z])       // should contain at least one lower case
  (?=.*[A-Z])       // should contain at least one upper case
*/

const passwordRegExp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])/;

export const strongPassword = (
  control: AbstractControl
): ValidationErrors | null => {
  if (!control.value.length) {
    return null;
  }

  if (control.value.length < 8) {
    return { PASSWORD_MIN_LENGTH_ERROR: true };
  }

  if (control.value.length > 128) {
    return { PASSWORD_MAX_LENGTH_ERROR: true };
  }

  if (!control.value.match(passwordRegExp)) {
    return { PASSWORD_STRENGTH_ERROR: true };
  }

  return null;
};
